import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import ProjectFilters from './components/ProjectFilters';
import ProjectTable from './components/ProjectTable';
import ProjectCreationModal from './components/ProjectCreationModal';
import ProjectStats from './components/ProjectStats';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const ProjectManagement = () => {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'asc' });
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // Mock project data
  const mockProjects = [
    {
      id: 1,
      name: 'Modernização de TI - ABC Corp',
      code: 'PROJ-2024-001',
      description: 'Atualização completa da infraestrutura de TI',
      client: {
        name: 'ABC Corporation',
        contact: 'João Silva',
        logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=100&h=100&fit=crop&crop=center'
      },
      startDate: '2024-01-15',
      endDate: '2024-06-30',
      status: 'active',
      priority: 'high',
      progress: 65,
      value: 250000,
      serviceOrders: 12,
      technicians: [
        {
          id: 1,
          name: 'João Silva',
          avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face'
        },
        {
          id: 2,
          name: 'Maria Santos',
          avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face'
        },
        {
          id: 3,
          name: 'Carlos Oliveira',
          avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face'
        }
      ],
      createdAt: '2024-01-10T10:00:00Z'
    },
    {
      id: 2,
      name: 'Implementação ERP - XYZ Ltd',
      code: 'PROJ-2024-002',
      description: 'Sistema integrado de gestão empresarial',
      client: {
        name: 'XYZ Limitada',
        contact: 'Ana Costa',
        logo: 'https://images.unsplash.com/photo-1549923746-c502d488b3ea?w=100&h=100&fit=crop&crop=center'
      },
      startDate: '2024-02-01',
      endDate: '2024-08-15',
      status: 'planning',
      priority: 'medium',
      progress: 25,
      value: 180000,
      serviceOrders: 8,
      technicians: [
        {
          id: 2,
          name: 'Maria Santos',
          avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face'
        },
        {
          id: 4,
          name: 'Ana Costa',
          avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face'
        }
      ],
      createdAt: '2024-01-25T14:30:00Z'
    },
    {
      id: 3,
      name: 'Segurança Cibernética - Tech Solutions',
      code: 'PROJ-2024-003',
      description: 'Auditoria e implementação de segurança',
      client: {
        name: 'Tech Solutions Brasil',
        contact: 'Pedro Ferreira',
        logo: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=100&h=100&fit=crop&crop=center'
      },
      startDate: '2024-03-01',
      endDate: '2024-05-30',
      status: 'active',
      priority: 'high',
      progress: 80,
      value: 120000,
      serviceOrders: 15,
      technicians: [
        {
          id: 1,
          name: 'João Silva',
          avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face'
        },
        {
          id: 5,
          name: 'Pedro Ferreira',
          avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face'
        }
      ],
      createdAt: '2024-02-20T09:15:00Z'
    },
    {
      id: 4,
      name: 'Migração para Cloud - Global Services',
      code: 'PROJ-2024-004',
      description: 'Migração completa para ambiente cloud',
      client: {
        name: 'Global Services Ltda',
        contact: 'Carla Mendes',
        logo: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=100&h=100&fit=crop&crop=center'
      },
      startDate: '2024-01-01',
      endDate: '2024-03-31',
      status: 'completed',
      priority: 'medium',
      progress: 100,
      value: 95000,
      serviceOrders: 6,
      technicians: [
        {
          id: 3,
          name: 'Carlos Oliveira',
          avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face'
        }
      ],
      createdAt: '2023-12-15T16:45:00Z'
    },
    {
      id: 5,
      name: 'Consultoria Estratégica - Innovate Co',
      code: 'PROJ-2024-005',
      description: 'Consultoria em transformação digital',
      client: {
        name: 'Innovate & Co',
        contact: 'Ricardo Santos',
        logo: 'https://images.unsplash.com/photo-1553484771-371a605b060b?w=100&h=100&fit=crop&crop=center'
      },
      startDate: '2024-04-01',
      endDate: '2024-07-31',
      status: 'on-hold',
      priority: 'low',
      progress: 40,
      value: 75000,
      serviceOrders: 4,
      technicians: [
        {
          id: 2,
          name: 'Maria Santos',
          avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face'
        },
        {
          id: 4,
          name: 'Ana Costa',
          avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face'
        }
      ],
      createdAt: '2024-03-20T11:20:00Z'
    }
  ];

  // Load projects on component mount
  useEffect(() => {
    const loadProjects = () => {
      setIsLoading(true);
      // Simulate API call delay
      setTimeout(() => {
        setProjects(mockProjects);
        setFilteredProjects(mockProjects);
        setIsLoading(false);
      }, 1000);
    };

    loadProjects();
  }, []);

  // Handle filters change
  const handleFiltersChange = (filters) => {
    let filtered = [...projects];

    // Search filter
    if (filters?.search) {
      const searchTerm = filters?.search?.toLowerCase();
      filtered = filtered?.filter(project =>
        project?.name?.toLowerCase()?.includes(searchTerm) ||
        project?.code?.toLowerCase()?.includes(searchTerm) ||
        project?.client?.name?.toLowerCase()?.includes(searchTerm) ||
        project?.description?.toLowerCase()?.includes(searchTerm)
      );
    }

    // Client filter
    if (filters?.client) {
      filtered = filtered?.filter(project => project?.client?.name?.includes(filters?.client));
    }

    // Status filter
    if (filters?.status) {
      filtered = filtered?.filter(project => project?.status === filters?.status);
    }

    // Date filters
    if (filters?.startDate) {
      filtered = filtered?.filter(project => 
        new Date(project.startDate) >= new Date(filters.startDate)
      );
    }

    if (filters?.endDate) {
      filtered = filtered?.filter(project => 
        new Date(project.endDate) <= new Date(filters.endDate)
      );
    }

    // Technician filter
    if (filters?.technician) {
      filtered = filtered?.filter(project =>
        project?.technicians?.some(tech => tech?.name?.includes(filters?.technician))
      );
    }

    setFilteredProjects(filtered);
  };

  // Handle sorting
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig?.key === key && sortConfig?.direction === 'asc') {
      direction = 'desc';
    }

    const sorted = [...filteredProjects]?.sort((a, b) => {
      let aValue = a?.[key];
      let bValue = b?.[key];

      // Handle nested properties
      if (key === 'client') {
        aValue = a?.client?.name;
        bValue = b?.client?.name;
      }

      // Handle date sorting
      if (key === 'startDate' || key === 'endDate') {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (aValue < bValue) {
        return direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });

    setFilteredProjects(sorted);
    setSortConfig({ key, direction });
  };

  // Handle project actions
  const handleProjectAction = (action, projectId) => {
    switch (action) {
      case 'create':
        setIsCreateModalOpen(true);
        break;
      case 'view':
        // Navigate to project details (would be implemented)
        console.log('View project:', projectId);
        break;
      case 'edit':
        // Open edit modal (would be implemented)
        console.log('Edit project:', projectId);
        break;
      case 'orders':
        // Navigate to service orders for this project
        navigate('/service-orders', { state: { projectId } });
        break;
      case 'activate':
        setProjects(prev => prev?.map(p => 
          p?.id === projectId ? { ...p, status: 'active' } : p
        ));
        break;
      case 'pause':
        setProjects(prev => prev?.map(p => 
          p?.id === projectId ? { ...p, status: 'on-hold' } : p
        ));
        break;
      case 'export':
        // Export functionality (would be implemented)
        console.log('Export projects:', projectId);
        break;
      default:
        console.log('Unknown action:', action);
    }
  };

  // Handle project creation
  const handleCreateProject = (projectData) => {
    const newProject = {
      ...projectData,
      client: {
        name: projectData?.client,
        contact: 'Contato Principal',
        logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=100&h=100&fit=crop&crop=center'
      },
      technicians: projectData?.technicians?.map(techId => ({
        id: techId,
        name: techId?.replace('-', ' ')?.replace(/\b\w/g, l => l?.toUpperCase()),
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face'
      }))
    };

    setProjects(prev => [newProject, ...prev]);
    setFilteredProjects(prev => [newProject, ...prev]);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-muted-foreground">Carregando projetos...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto px-4 py-8">
        {/* Page Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Gerenciamento de Projetos
            </h1>
            <p className="text-muted-foreground">
              Controle e monitore todos os projetos de consultoria da empresa
            </p>
          </div>
          <div className="flex items-center space-x-3 mt-4 sm:mt-0">
            <Button
              variant="outline"
              onClick={() => navigate('/admin-dashboard')}
              iconName="ArrowLeft"
              iconPosition="left"
            >
              Voltar ao Dashboard
            </Button>
            <Button
              variant="default"
              onClick={() => setIsCreateModalOpen(true)}
              iconName="Plus"
              iconPosition="left"
            >
              Novo Projeto
            </Button>
          </div>
        </div>

        {/* Project Statistics */}
        <ProjectStats projects={filteredProjects} />

        {/* Filters */}
        <ProjectFilters
          onFiltersChange={handleFiltersChange}
          onCreateProject={() => setIsCreateModalOpen(true)}
        />

        {/* Projects Table */}
        <ProjectTable
          projects={filteredProjects}
          onProjectAction={handleProjectAction}
          onSort={handleSort}
          sortConfig={sortConfig}
        />

        {/* Pagination would go here */}
        {filteredProjects?.length > 0 && (
          <div className="flex items-center justify-between mt-6">
            <p className="text-sm text-muted-foreground">
              Mostrando {filteredProjects?.length} de {projects?.length} projetos
            </p>
            <div className="flex items-center space-x-2">
              <Button variant="outline" size="sm" disabled>
                <Icon name="ChevronLeft" size={16} />
              </Button>
              <Button variant="outline" size="sm">
                1
              </Button>
              <Button variant="outline" size="sm" disabled>
                <Icon name="ChevronRight" size={16} />
              </Button>
            </div>
          </div>
        )}
      </div>
      {/* Create Project Modal */}
      <ProjectCreationModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSave={handleCreateProject}
      />
    </div>
  );
};

export default ProjectManagement;